import _cloneDeep from 'lodash/cloneDeep';

const T = require('./types');

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case T.UPDATE: {
      const { config } = action;

      const nextState = _cloneDeep({
        ...state,
        ...config,
      });

      return nextState;
    }
    default: {
      return state;
    }
  }
}
